<div class="mb-3">
  <div *ngIf="detailInfo.inputContentDatas as inputContentDatas">
    <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
      <div class="d-flex flex-row flex-wrap gap-2">
        <div
          *ngFor="let parameter of inputContentDatas"
          [class.w-100]="parameter.extraValueType === InputContentDataExtraValueType.Textarea"
        >
          <input
            type="checkbox"
            class="form-check-input me-1"
            [value]="parameter.key"
            (change)="selectOption($event, parameter)"
            [checked]="parameter.checked"
            [disabled]="formControlObj.disabled"
            [id]="'detail-info-check-' + detailInfo.evideInputContentGuid + '-' + parameter.key"
          />
          <label
            class="form-check-label"
            [for]="'detail-info-check-' + detailInfo.evideInputContentGuid + '-' + parameter.key"
          >
            {{ parameter.value }}</label
          >
          <input
            class="bottom-border-input form-control"
            [(ngModel)]="parameter.extraValue"
            [disabled]="!parameter.checked || formControlObj.disabled"
            (ngModelChange)="onExtraOptionValueChange(parameter)"
            [ngModelOptions]="{ standalone: true }"
            *ngIf="
              parameter.extraValueType ===
              InputContentDataExtraValueType.Textbox
            "
            type="text"
          />
          <textarea
            class="form-control mt-1"
            style="white-space: pre-line"
            rows="3"
            [(ngModel)]="parameter.extraValue"
            [disabled]="formControlObj.disabled"
            (ngModelChange)="onExtraOptionValueChange(parameter)"
            [ngModelOptions]="{ standalone: true }"
            *ngIf="
              parameter.extraValueType ===
                InputContentDataExtraValueType.Textarea && parameter.checked
            "
          ></textarea>
        </div>
      </div>
    </app-field-title>
  </div>
</div>
